import * as React from 'react';

interface Props {
  snapNumber: number;
  setCurrentSnapTile: (snap: any) => void;
  snapshot: any;
  setCurrentDrawLayer: (layer: number[][]) => void;
}

const Snapshot = (props: Props) => {
  const {
    setCurrentSnapTile,
    snapNumber,
    snapshot,
  } = props;

  const setCurrentSnap = React.useCallback(() => {
    setCurrentSnapTile(snapshot.tms.replace('{band}', 'B04,B03,B02'));
  }, [snapshot]);

  return (
    <button
      className='primary-button tile-button'
      onClick={setCurrentSnap}>{snapNumber}</button>
  );
};

export default Snapshot;
